<template>
  <div :class="classes.container">
    <div :class="classes.wrapper">
      <CardHeader :eventId="eventId" />

      <EventName
        :eventId="eventId"
        :class="classes.eventName"
        class="event-name"
      />

      <MarketTags :tags="tags" />

      <div :class="classes.options">
        <Button
          :stagger="0"
          :class="classes.button"
          :optionId="homeAwayOptions[0].options[overUnder ? 1 : 0]"
          :marketId="homeAwayOptions[0].marketId"
        />

        <div :class="classes.divider" />

        <Button
          :stagger="1"
          :class="classes.button"
          :optionId="homeAwayOptions[0].options[overUnder ? 0 : 1]"
          :marketId="homeAwayOptions[0].marketId"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { defineComponent, ref, computed, ComputedRef } from "vue";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";

import EventName from "../../../EventNamesBadgesVertical.vue";
import CardHeader from "../../../CardHeader.vue";
import MarketTags from "../../../MarketTags.vue";
import Button from "../Button.vue";

import {
  composeHomeAwayOptions,
  composeMarket
} from "@fresh8/ad-data-composition/src/betData";
import { Market } from "@fresh8/types/src/betData";

const useStyles = createUseStyles({
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "column"
  },
  market: {
    padding: "0"
  },
  vs: {
    background: props =>
      props.backgroundImage ? "none" : props.backgroundColor,
    display: "block",
    padding: "0 5px",
    zIndex: 1,
    position: "relative"
  },
  divider: {
    width: "100%",
    height: "1px",
    background: props => `${props.marketBorderColor || "#dcddf"}`,
    marginBottom: "1px"
  },
  wrapper: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    height: "100%",
    border: props => `1px solid ${props.marketBorderColor || "#dcddf"}`,
    background: props => props.cardBackgroundColor,
    borderRadius: props => `${props.borderRadius}px`,
    paddingBottom: "8px"
  },
  eventMarketWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "8px",
    boxSizing: "border-box"
  },
  options: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "0 8px"
  },
  button: {
    flex: 1,
    marginBottom: "15px",
    marginTop: "5px",
    "&:last-of-type": {
      marginTop: "15px",
      marginBottom: "13px"
    }
  },
  eventName: {
    borderBottom: props => `1px solid ${props.marketBorderColor || "#dcddf"}`
  }
});

export default defineComponent({
  name: "Card",
  components: {
    CardHeader,
    Button,
    EventName,
    MarketTags
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const {
      adTemplateBranding,
      marketBranding,
      backgroundImageSets
    } = injectBrand();
    const marketId = ref([props.marketId]);
    const matketData = composeMarket(props.marketId) as ComputedRef<Market>;

    const marketType = computed(() => matketData.value?.marketType);
    const marketName = computed(() => matketData.value?.marketName);

    const overUnder = computed(() => marketType.value === "Over/Under Totals");

    const backgroundImage = computed(() => {
      return !!Object.keys(backgroundImageSets?.value || {}).length;
    });

    const relativeStyles = computed(() => ({
      ...adTemplateBranding.value,
      backgroundImage: backgroundImage.value
    }));

    const classesRef = useStyles(relativeStyles);

    const homeAwayOptions = composeHomeAwayOptions(marketId);

    return {
      overUnder,
      marketBranding,
      classes: classesRef,
      homeAwayOptions,
      tags: [marketName.value]
    };
  }
});
</script>
